import { take } from "rxjs/operators";
import {
  ChartData,
  UserGroups,
  TreeMap
} from "./../../../assets/config/models";
import { CoreService } from "./../../services/coreService";
import {
  Component,
  AfterViewInit,
  ViewChild,
  ChangeDetectorRef
} from "@angular/core";
import { DatePipe } from "@angular/common";
import * as _ from "lodash";
import { Router, Route, ActivatedRoute } from "@angular/router";

declare var toastr: any;

@Component({
    selector: "app-dashboard",
    templateUrl: "./dashboard.component.html",
    styleUrls: ["./dashboard.component.scss"],
    providers: [CoreService],
    standalone: true
})
export class DashboardComponent {
  // bsConfig: Partial<BsDatepickerConfig>;
  // dateRange: Date[] = [];
  // userDetails: any;
  // visitorsLoading = false;
  // revenuesLoading = false;
  // capacityLoading = false;
  // averageLoading = false;
  // topupLoading = false;
  // peakHoursLoading = false;
  // ageLoading = false;
  // genderLoading = false;

  // displayRevenuesDetails = false;
  // displayVisitorsDetails = false;

  // // Settings shared between charts.
  // sharedSettings = {
  //   showXAxis: true,
  //   showYAxis: true,
  //   gradient: false,
  //   showLegend: false,
  //   showXAxisLabel: true,
  //   showYAxisLabel: true,
  //   roundDomains: false,
  //   animations: true,
  //   colorScheme: this.coreService.passColorScheme,
  //   additionalColorsScheme: {
  //     domain: [
  //       ...this.coreService.passColorScheme.domain,
  //       ...this.coreService.colorScheme.domain
  //     ]
  //   }
  // };

  // passColor = this.coreService.passColor;
  // passColorScheme = this.coreService.passColorScheme;

  // customGenderColor = [
  //   {
  //     name: "Males",
  //     value: this.passColor
  //   },
  //   {
  //     name: "Females",
  //     value: "#FF1493"
  //   }
  // ];

  // visitorsChart: ChartData[];
  // visitorsHours: ChartData[] = [];
  // // Data to check ID from title
  // visitorsData;

  // averageTimeChart: ChartData[];

  // topupChart: ChartData[];

  // revenueChart: ChartData[];
  // // Data to check ID from title
  // revenueData;

  // peakHoursChart: ChartData[];
  // ageChart: ChartData[];
  // genderChart: ChartData[];

  // groupName: any;
  // groupTypes = UserGroups;

  // currentVisitorId;

  // constructor(
  //   private coreService: CoreService,
  //   private datePipe: DatePipe,
  //   private changeDetector: ChangeDetectorRef,
  //   private db: AngularFireDatabase,
  //   private router: Router,
  //   private route: ActivatedRoute
  // ) {
  //   this.userDetails = JSON.parse(localStorage.getItem("user_details"));
  //   let endDate = new Date();
  //   console.log(endDate.toLocaleString());
  //   let startDate = new Date();
  //   startDate.setDate(endDate.getDate() - 1);
  //   this.dateRange.push(startDate, endDate);
  //   this.bsConfig = this.coreService.bsConfig;
  //   this.groupName = this.userDetails.group;
  //   this.configureCharts(this.dateRange);
  // }

  // onDateRangeChanged(event) {
  //   this.dateRange = event;
  //   console.log("Dashboard date range", this.dateRange);
  //   this.configureCharts(this.dateRange);
  // }

  // onHeatMapItemClick(id) {
  //   console.log("Router shit is", this.router.getCurrentNavigation());
  //   switch (id) {
  //     case TreeMap.LIVE_PASS: {
  //       this.router.navigate([
  //         "/user/reports/pass_tickets",
  //         {
  //           form: JSON.stringify({
  //             ticket_type: "open"
  //           }),
  //           date: JSON.stringify(this.dateRange)
  //         }
  //       ]);
  //       break;
  //     }
  //     case TreeMap.LIVE_MANUAL: {
  //       this.router.navigate([
  //         "/user/reports/manual_tickets",
  //         {
  //           form: JSON.stringify({
  //             ticket_type: "open"
  //           }),
  //           date: JSON.stringify(this.dateRange)
  //         }
  //       ]);
  //       break;
  //     }
  //     case TreeMap.CLOSED_PASS: {
  //       this.router.navigate([
  //         "/user/reports/pass_tickets",
  //         {
  //           form: JSON.stringify({
  //             ticket_type: "closed"
  //           }),
  //           date: JSON.stringify(this.dateRange)
  //         }
  //       ]);
  //       break;
  //     }
  //     case TreeMap.CLOSED_MANUAL: {
  //       this.router.navigate([
  //         "/user/reports/manual_tickets",
  //         {
  //           form: JSON.stringify({
  //             ticket_type: "closed"
  //           }),
  //           date: JSON.stringify(this.dateRange)
  //         }
  //       ]);
  //       break;
  //     }
  //     case TreeMap.ALL: {
  //       break;
  //     }
  //     case TreeMap.CLOSED_SUBSCRIBER: {
  //       this.router.navigate([
  //         "/user/reports/subscriber-tickets",
  //         {
  //           form: JSON.stringify({
  //             ticket_type: "closed"
  //           }),
  //           date: JSON.stringify(this.dateRange)
  //         }
  //       ]);
  //       break;
  //     }
  //     case TreeMap.LIVE_GUEST: {
  //       this.router.navigate([
  //         "/user/reports/unregistered_tickets",
  //         {
  //           form: JSON.stringify({
  //             status: "open"
  //           }),
  //           date: JSON.stringify(this.dateRange)
  //         }
  //       ]);
  //       break;
  //     }
  //     case TreeMap.LIVE_SUBSCRIBER: {
  //       this.router.navigate([
  //         "/user/reports/subscriber-tickets",
  //         {
  //           form: JSON.stringify({
  //             ticket_type: "open"
  //           }),
  //           date: JSON.stringify(this.dateRange)
  //         }
  //       ]);
  //       break;
  //     }
  //     case TreeMap.CLOSED_GUEST: {
  //       this.router.navigate([
  //         "/user/reports/unregistered_tickets",
  //         {
  //           form: JSON.stringify({
  //             status: "closed"
  //           }),
  //           date: JSON.stringify(this.dateRange)
  //         }
  //       ]);
  //       break;
  //     }
  //     case TreeMap.LIVE_COMPANY: {
  //       this.router.navigate([
  //         "/user/reports/company_subscribers",
  //         {
  //           form: JSON.stringify({
  //             ticket_type: "open"
  //           }),
  //           date: JSON.stringify(this.dateRange)
  //         }
  //       ]);
  //       break;
  //     }
  //     case TreeMap.CLOSED_COMPANY: {
  //       this.router.navigate([
  //         "/user/reports/company_subscribers",
  //         {
  //           form: JSON.stringify({
  //             ticket_type: "closed"
  //           }),
  //           date: JSON.stringify(this.dateRange)
  //         }
  //       ]);
  //       break;
  //     }
  //     default: {
  //       break;
  //     }
  //   }
  // }

  // async configureVisitorsChart() {
  //   let temp: ChartData[] = [];
  //   this.visitorsData.forEach(parking => {
  //     let tempObject: ChartData = { name: parking.title, series: [] };
  //     tempObject.series.push({
  //       name: "Registered",
  //       value: parking.registered_count
  //     });

  //     tempObject.series.push({
  //       name: "Unregistered",
  //       value: parking.unregistered_count
  //     });
  //     temp.push(tempObject);
  //   });
  //   this.visitorsChart = [...temp];
  // }

  // async configureVisitorsDetailsChart(response) {
  //   let temp: ChartData[] = [];
  //   response.parking_places = _.orderBy(
  //     response.parking_places,
  //     element => element.day as any,
  //     ["asc"]
  //   );

  //   response.parking_places.forEach(parking => {
  //     let tempObject: ChartData = {
  //       name: this.datePipe.transform(parking.day, "dd-MM-yyyy").toString(),
  //       series: []
  //     };
  //     tempObject.series.push({
  //       name: "Registered",
  //       value: parking.registered_count
  //     });

  //     tempObject.series.push({
  //       name: "Unegistered",
  //       value: parking.unregistered_count
  //     });
  //     temp.push(tempObject);
  //   });
  //   this.visitorsChart = [...temp];
  // }

  // async configureAverageChart(average) {
  //   let temp: ChartData[] = [];
  //   average.parking_places.forEach(parking => {
  //     temp.push({
  //       name: parking.title,
  //       value: parking.average_time
  //     });
  //   });
  //   this.averageTimeChart = [...temp];
  // }

  // async configureTopupChart(response) {
  //   let temp: ChartData[] = [];
  //   response.parking_topups = _.orderBy(
  //     response.parking_topups,
  //     element => element.day as any,
  //     ["asc"]
  //   );

  //   response.parking_topups.forEach(topup => {
  //     temp.push({
  //       name: this.datePipe.transform(topup.day, "dd-MM-yyyy").toString(),
  //       value: topup.total_amount
  //     });
  //   });
  //   this.topupChart = [...temp];
  // }

  // async configureRevenuesChart() {
  //   let temp: ChartData[] = [];

  //   this.revenueData.forEach((parking, parkingIndex) => {
  //     let tempObject: ChartData = { name: parking.parking_place, series: [] };
  //     parking.beneficiary.forEach(element => {
  //       tempObject.series.push({
  //         name: element.name,
  //         value: element.amount
  //       });
  //     });
  //     temp.push(tempObject);
  //   });
  //   console.log("revenueChart", temp);
  //   this.revenueChart = [...temp];
  // }

  // async configurePeakHoursChart(response) {
  //   let temp: ChartData[] = [];
  //   let names: Array<string> = response.map(parking => {
  //     return parking.hours.map(hour => hour.hour);
  //   });

  //   names = _.flatten(names);
  //   names = _.uniq(names);
  //   names = _.sortBy(names, name => name);

  //   temp = names.map(name => ({ name, series: [] }));

  //   temp.forEach(element => {
  //     response.forEach(parking => {
  //       parking.hours.forEach(hour => {
  //         if (hour.hour == element.name) {
  //           element.series.push({
  //             name: parking.title,
  //             value: hour.parking_count
  //           });
  //         }
  //       });
  //     });
  //   });
  //   this.peakHoursChart = [...temp];
  // }

  // async configureAgeChart(response) {
  //   let temp: ChartData[] = [];
  //   let names: Array<string> = response.map(parking => {
  //     return parking.age_breakdown.map(age => age.label);
  //   });

  //   names = _.flatten(names);
  //   names = _.uniq(names);
  //   names = _.sortBy(names, name => name);

  //   temp = names.map(name => ({ name, series: [] }));

  //   temp.forEach(element => {
  //     response.forEach(parking => {
  //       parking.age_breakdown.forEach(age => {
  //         if (age.label == element.name) {
  //           element.series.push({
  //             name: parking.title,
  //             value: age.count==null? 0: age.count
  //           });
  //         }
  //       });
  //     });
  //   });
  //   this.ageChart = [...temp];
  // }

  // async configureGenderChart(response) {
  //   let temp: ChartData[] = [];
  //   /* let names: Array<string> = response.map(parking => {
  //     return parking.gender_breakdown.map(gender => gender.label);
  //   });

  //   names = _.flatten(names);
  //   names = _.uniq(names);
  //   names = _.sortBy(names, name => name);

  //   temp = names.map(name => ({ name, value: 0 })); */

  //   response.forEach(parking => {
  //     temp.push({
  //       name: parking.title,
  //       series: parking.gender_breakdown.map(gender => ({
  //         name: gender.label,
  //         value: gender.count
  //       }))
  //     });
  //   });
  //   this.genderChart = [...temp];
  // }

  // async configureCharts(date) {
  //   this.visitorsLoading = true;
  //   this.revenuesLoading = true;
  //   this.averageLoading = true;
  //   this.topupLoading = true;
  //   this.genderLoading = true;
  //   this.ageLoading = true;
  //   this.peakHoursLoading = true;

  //   let average;
  //   let topup;
  //   let peakHours;
  //   let age;
  //   let gender;
  //   try {
  //     [
  //       this.visitorsData,
  //       this.revenueData,
  //       average,
  //       topup,
  //       peakHours,
  //       age,
  //       gender
  //     ] = await Promise.all([
  //       this.coreService
  //         .GetVisitors(date)
  //         .then(response => response.parking_places),
  //       this.coreService.GetRevenues(date).then(response => response.revenues),
  //       this.coreService.GetAverageTimeSpent(date),
  //       this.coreService.GetTopup(date),
  //       this.coreService.GetPeakHours(date),
  //       this.coreService.GetAgeChart(date),
  //       this.coreService.GetGendersChart(date)
  //     ]);
  //     this.configureVisitorsChart();
  //     this.configureRevenuesChart();
  //     this.configureAverageChart(average);
  //     this.configureTopupChart(topup);
  //     this.configurePeakHoursChart(peakHours);
  //     this.configureAgeChart(age);
  //     this.configureGenderChart(gender);
  //   } catch (error) {
  //     console.log(error || error.message);
  //   } finally {
  //     this.visitorsLoading = false;
  //     this.revenuesLoading = false;
  //     this.averageLoading = false;
  //     this.topupLoading = false;
  //     this.genderLoading = false;
  //     this.ageLoading = false;
  //     this.peakHoursLoading = false;
  //   }
  // }

  // async onSelectVisitorsChart(event) {
  //   console.log(event);
  //   this.visitorsLoading = true;
  //   switch (this.displayVisitorsDetails) {
  //     case true: {
  //       this.displayVisitorsDetails = null;
  //       this.visitorsHours.length = 0;
  //       break;
  //     }
  //     case false: {
  //       this.displayVisitorsDetails = true;
  //       this.visitorsHours.length = 0;
  //       break;
  //     }
  //     case null: {
  //       this.displayVisitorsDetails = false;
  //       this.visitorsHours.length = 0;
  //       break;
  //     }
  //     default: {
  //       console.log("I shouldn't be here");
  //     }
  //   }
  //   console.log("displayVisistorsDetails: ", this.displayVisitorsDetails);
  //   let temp: ChartData[] = [];
  //   try {
  //     if (this.displayVisitorsDetails == null) {
  //       console.log(" current ID", this.currentVisitorId);
  //       console.log("test: ", event.series);
  //       let live$ = this.db
  //         .list(
  //           `/parking/${this.currentVisitorId}/dates/${event.series}`,
  //           ref => ref.limitToLast(60 * 24)
  //         )
  //         .snapshotChanges()
  //         .pipe(take(1));
  //       live$.subscribe(live_parking => {
  //         console.log("live parking visitors", live_parking);
  //         if (live_parking.length > 0) {
  //           temp.push({
  //             name: "Pass",
  //             series: []
  //           });
  //           temp.push({
  //             name: "Unregistered",
  //             series: []
  //           });
  //           live_parking.forEach((element: any) => {
  //             temp[0].series.push({
  //               name: this.datePipe
  //                 .transform(element.payload.val().date, "HH:mm")
  //                 .toString(),
  //               value: element.payload.val().registered_count
  //             });
  //             temp[1].series.push({
  //               name: this.datePipe
  //                 .transform(element.payload.val().date, "HH:mm")
  //                 .toString(),
  //               value: element.payload.val().unregistered_count
  //             });
  //           });
  //           this.visitorsHours = [...temp];
  //         } else {
  //           toastr.error("", "No Data to display", {
  //             timeOut: 2000
  //           });
  //           this.displayVisitorsDetails = true;
  //         }
  //       });
  //     } else if (this.displayVisitorsDetails == true) {
  //       this.currentVisitorId = this.visitorsData.find(
  //         element => element.title == event.series
  //       ).id;
  //       let response = await this.coreService.GetVisitorsDetails(
  //         this.currentVisitorId,
  //         this.dateRange
  //       );
  //       this.configureVisitorsDetailsChart(response);
  //     } else {
  //       await this.configureVisitorsChart();
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     this.visitorsLoading = false;
  //   }
  // }

  // async onSelectRevenuesChart(event) {
  //   console.log(typeof event === "string");
  //   if (!(typeof event === "string")) {
  //     this.revenuesLoading = true;
  //     this.displayRevenuesDetails = this.displayRevenuesDetails ? false : true;
  //     let temp: ChartData[] = [];
  //     try {
  //       if (this.displayRevenuesDetails) {
  //         console.log(this.revenueData);
  //         let response = await this.coreService.GetRevenuesDetails(
  //           this.revenueData.find(
  //             element => element.parking_place == event.series
  //           ).id,
  //           this.dateRange
  //         );

  //         response.revenues = _.orderBy(
  //           response.revenues,
  //           element => element.day as any,
  //           ["asc"]
  //         );

  //         response.revenues.forEach((element, revenueIndex) => {
  //           let tempObject: ChartData = {
  //             name: this.datePipe
  //               .transform(element.day, "dd-MM-yyyy")
  //               .toString(),
  //             series: []
  //           };
  //           element.beneficiary.forEach((beneficiary, index) => {
  //             tempObject.series.push({
  //               name: beneficiary.name,
  //               value: beneficiary.amount
  //             });
  //           });
  //           temp.push(tempObject);
  //         });
  //         this.revenueChart = [...temp];
  //       } else {
  //         await this.configureRevenuesChart();
  //       }
  //     } catch (error) {
  //       console.log(error);
  //     } finally {
  //       this.revenuesLoading = false;
  //     }
  //   }
  // }
}
